import React from 'react'
import classes from './ScreenModalContent.module.sass'

type Props = {
  image: string
}

export const ScreenModalContent = ({ image }: Props) => {
  return (
    <div className={classes.Container}>
      <img src={image} alt="Экран" className={classes.Image} />
    </div>
  )
}
